module.exports = __webpack_public_path__ + "img/RESTAURATION.e049929b.svg";